<template>
  <div id="allExpertises" dir="rtl">
    <div class="tile is-ancestor">
      <div class="tile is-vertical">
        <div class="tile">
          <div class="tile is-parent is-vertical">
            <!-- damages -->
            <article class="tile is-child notification">
              <button class="delete is-small" v-show="damages" @click="damages = false" />
              <div class="content" v-show="!damages">
                <p class="subtitle">
                  {{allExpertises.damages.title}}
                  <b-icon pack="fas" icon="medkit" size="is-small" class="icon" />
                </p>
                <p class="details-click" @click="damages = true">קרא עוד</p>
              </div>
              <div class="content details-content" v-show="damages">
                <p
                  class="details"
                  v-for="(paragraph, index) of allExpertises.damages.content"
                  :key="index"
                  v-html="paragraph"
                />
              </div>
            </article>

            <!-- realEstate -->
            <article class="tile is-child notification">
              <button class="delete is-small" v-show="realEstate" @click="realEstate = false" />
              <div class="content" v-show="!realEstate">
                <p class="subtitle">
                  {{allExpertises.realEstate.title}}
                  <b-icon pack="fas" icon="home" size="is-small" class="icon" />
                </p>
                <p class="details-click" @click="realEstate = true">קרא עוד</p>
              </div>
              <div class="content details-content" v-show="realEstate">
                <p
                  class="details"
                  v-for="(paragraph, index) of allExpertises.realEstate.content"
                  :key="index"
                  v-html="paragraph"
                />
              </div>
            </article>

            <!-- litigation -->
            <article class="tile is-child notification">
              <button class="delete is-small" v-show="litigation" @click="litigation = false" />
              <div class="content" v-show="!litigation">
                <p class="subtitle">
                  {{allExpertises.litigation.title}}
                  <b-icon pack="fas" icon="gavel" size="is-small" class="icon" />
                </p>
                <p class="details-click" @click="litigation = true">קרא עוד</p>
              </div>
              <div class="content details-content" v-show="litigation">
                <p
                  class="details"
                  v-for="(paragraph, index) of allExpertises.litigation.content"
                  :key="index"
                  v-html="paragraph"
                />
              </div>
            </article>
          </div>
        </div>
      </div>

      <div class="tile is-vertical">
        <div class="tile">
          <div class="tile is-parent is-vertical">
            <!-- leumi -->
            <article class="tile is-child notification">
              <button class="delete is-small" v-show="leumi" @click="leumi = false" />
              <div class="content" v-show="!leumi">
                <p class="subtitle">
                  {{allExpertises.leumi.title}}
                  <img
                    src="../../images/bituah_leumi_reduced.png"
                    id="bituah_leumi-icon"
                  />
                </p>
                <p class="details-click" @click="leumi = true">קרא עוד</p>
              </div>
              <div class="content details-content" v-show="leumi">
                <p
                  class="details"
                  v-for="(paragraph, index) of allExpertises.leumi.content"
                  :key="index"
                  v-html="paragraph"
                />
              </div>
            </article>

            <!-- inheritance -->
            <article class="tile is-child notification">
              <button class="delete is-small" v-show="inheritance" @click="inheritance = false" />
              <div class="content" v-show="!inheritance">
                <p class="subtitle">
                  {{allExpertises.inheritance.title}}
                  <b-icon pack="fas" icon="coins" size="is-small" class="icon" />
                </p>
                <p class="details-click" @click="inheritance = true">קרא עוד</p>
              </div>
              <div class="content details-content" v-show="inheritance">
                <p
                  class="details"
                  v-for="(paragraph, index) of allExpertises.inheritance.content"
                  :key="index"
                  v-html="paragraph"
                />
              </div>
            </article>

            <!-- notary -->
            <article class="tile is-child notification">
              <button class="delete is-small" v-show="notary" @click="notary = false" />
              <div class="content" v-show="!notary">
                <p class="subtitle">
                  {{allExpertises.notary.title}}
                  <b-icon pack="fas" icon="stamp" size="is-small" class="icon" />
                </p>
                <p class="details-click" @click="notary = true">קרא עוד</p>
              </div>
              <div class="content details-content" v-show="notary">
                <p
                  class="details"
                  v-for="(paragraph, index) of allExpertises.notary.content"
                  :key="index"
                  v-html="paragraph"
                />
              </div>
            </article>
          </div>
        </div>
      </div>

      <!-- insuranceClaims -->
      <div class="tile is-vertical">
        <div class="tile">
          <div class="tile is-parent is-vertical">
            <article class="tile is-child notification">
              <button
                class="delete is-small"
                v-show="insuranceClaims"
                @click="insuranceClaims = false"
              />
              <div class="content" v-show="!insuranceClaims">
                <p class="subtitle">
                  {{allExpertises.insuranceClaims.title}}
                  <b-icon pack="fas" icon="hand-holding-usd" size="is-small" class="icon" />
                </p>
                <p
                  class="details-click"
                  @click="insuranceClaims = true"
                >קרא עוד</p>
              </div>
              <div class="content details-content" v-show="insuranceClaims">
                <p
                  class="details"
                  v-for="(paragraph, index) of allExpertises.insuranceClaims.content"
                  :key="index"
                  v-html="paragraph"
                />
              </div>
            </article>

            <!-- labor -->
            <article class="tile is-child notification">
              <button class="delete is-small" v-show="labor" @click="labor = false" />
              <div class="content" v-show="!labor">
                <p class="subtitle">
                  {{allExpertises.labor.title}}
                  <b-icon pack="fas" icon="user-tie" size="is-small" class="icon" />
                </p>
                <p class="details-click" @click="labor = true">קרא עוד</p>
              </div>
              <div class="content details-content" v-show="labor">
                <p
                  class="details"
                  v-for="(paragraph, index) of allExpertises.labor.content"
                  :key="index"
                  v-html="paragraph"
                />
              </div>
            </article>

            <!-- powerOfAttorney -->
            <article class="tile is-child notification">
              <button
                class="delete is-small"
                v-show="powerOfAttorney"
                @click="powerOfAttorney = false"
              />
              <div class="content" v-show="!powerOfAttorney">
                <p class="subtitle">
                  {{allExpertises.powerOfAttorney.title}}
                  <b-icon pack="fas" icon="balance-scale" size="is-small" class="icon" />
                </p>
                <p class="details-click" @click="powerOfAttorney = true">קרא עוד</p>
              </div>
              <div class="content details-content" v-show="powerOfAttorney">
                <p
                  class="details"
                  v-for="(paragraph, index) of allExpertises.powerOfAttorney.content"
                  :key="index"
                  v-html="paragraph"
                />
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import allExpertisesJson from "../../public/AllExpertises.json";

export default {
  name: "allExpertises",
  data() {
    return {
      allExpertises: allExpertisesJson,
      damages: false,
      leumi: false,
      insuranceClaims: false,
      realEstate: false,
      inheritance: false,
      labor: false,
      litigation: false,
      notary: false,
      powerOfAttorney: false
    };
  }
};
</script>

<style scoped>
#allExpertises {
  padding-top: 0.5vh;
}
.is-child {
  min-height: 31vh;
  border-style: solid;
  border-color: lightgray;
  border-width: 1px;
}
.delete {
  background-color: #99b3ff;
  text-align: left;
}
.subtitle {
  font-size: 170%;
  text-align: center;
}
.icon {
  padding-right: 2.2vh;
  color: #001a66;
}
#bituah_leumi-icon {
  width: 3.95vh;
  text-align: center;
  margin-bottom: -0.7vh;
}
.details-click {
  font-size: 140%;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  color: #99b3ff;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  position: absolute;
  bottom: 16.5%;
  left: 10.8%;
}
.details-content {
  margin-top: -1.4vh;
}
.details {
  font-size: 74%;
  font-weight: 700;
  color: #001a66;
  text-align: justify;
}
</style>